import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GetDealerBirthDateDetailsQueryResponse } from '@models/reports/reports';
import { ModalComponent } from 'src/app/components/modal/modal.component';

@Component({
  selector: 'app-profile-data-modal',
  templateUrl: './profile-data-modal.component.html',
  styleUrl: './profile-data-modal.component.scss'
})
export class ProfileDataModalComponent extends ModalComponent<ProfileDataModalComponent> implements OnInit {
  public loading: boolean;
  public form: FormGroup;
  public client: any;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: GetDealerBirthDateDetailsQueryResponse,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.loadClient();
  }

  public async loadClient(): Promise<void> {
    this.loading = true;

    this.client = this.data;
    this.loading = false;
  }
}
